import React from "react";

function Label() {
  return (
    <div  className="flex flex-row justify-between p-3   ">
      <p>یادداشت‌ها</p>
      <p>مشاهده</p>
    </div>
  );
}

export default Label;
